var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarAltV2O(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.667a1 1 0 0 1 1 1v3.666h14V5.667a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v3.666h4.667A4.667 4.667 0 0 1 51.333 14v32.667a4.667 4.667 0 0 1-4.666 4.666H9.333a4.667 4.667 0 0 1-4.666-4.666V14a4.667 4.667 0 0 1 4.666-4.667H14V5.667a1 1 0 0 1 1-1h5zm26.667 21H9.333v21h37.334v-21zm-10.09 5.181c.877.805.998 2.124.327 3.07l-.185.227-7 7.629a2.334 2.334 0 0 1-3.173.247l-.21-.189-4.85-4.931a2.333 2.333 0 0 1 3.11-3.468l.218.196 3.128 3.18 5.339-5.819a2.333 2.333 0 0 1 3.297-.142zM46.668 14H9.333v7h37.334v-7z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAltV2O);
export default __webpack_public_path__ + "static/media/calendar-alt-v-2-o.b349188c.svg";
export { ForwardRef as ReactComponent };